import React from 'react';
import classnames from 'classnames';
import type { PapiDeviation } from '@wix/da-papi-types';
import Ellipsis from '@wix/da-ds/pkg/Icons/Ellipsis';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import type { NullableDropdownItem } from '@wix/da-ds/pkg/Dropdown/types';
import UserIdentityLargeMobile from '../../../../../User/IdentityLargeMobile';
import ThumbActions from '../../../../Helper/ThumbActions';
import { useOverlayContext } from '../../../../hooks/useOverlayContext';
import TopInfoBarWatchButton from './TopInfoBarWatchButton';
import s from './TopInfoBar.scss';

interface Props {
  deviation: PapiDeviation;
  extraActions?: NullableDropdownItem[];
  className?: string;
}

const TopInfoBar: React.FC<Props> = ({
  deviation,
  extraActions,
  className,
}) => {
  const { showAuthorWatchButton } = useOverlayContext(deviation);
  return (
    <div className={classnames(s['root'], className)}>
      <div className={s['left']}>
        <UserIdentityLargeMobile
          user={deviation.author}
          deviation={deviation}
          className={s['author']}
        />
      </div>
      <div className={s['right']}>
        {showAuthorWatchButton && (
          <TopInfoBarWatchButton deviation={deviation} />
        )}

        {extraActions && (
          <ThumbActions
            className={s['actions']}
            actions={extraActions}
            deviation={deviation}
          >
            <Ellipsis size={IconSize.MEDIUM} disableDefaultColors />
          </ThumbActions>
        )}
      </div>
    </div>
  );
};
TopInfoBar.displayName = 'TopInfoBar';

export default TopInfoBar;
